<div class="col-sm-10 col-md-8 col-lg-6 mx-auto my-2" data-testid="waitlist-step">
    <ng-container *ngIf="!waitlistSubmitted">
        <div class="text-center mb-3">
            <h5 class="fw-semibold mb-1">Join the Waitlist</h5>
            <div class="text-body-secondary fw-normal">
                We&apos;ll let you know if a spot opens up.
            </div>
        </div>

        <form
            class="vstack gap-3"
            data-testid="waitlist-form"
            [formGroup]="form"
        >
            <div class="row g-2">
                <div class="col-sm-6">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="First Name"
                        autocapitalize="words"
                        autocomplete="given-name"
                        appCapitaliseOnBlur
                        formControlName="firstName"
                        data-testid="waitlist-first-name"
                        [ngClass]="{
                            'is-invalid': form.get('firstName')?.invalid && form.get('firstName')?.touched
                        }"
                    />
                </div>
                <div class="col-sm-6">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Surname"
                        autocapitalize="words"
                        autocomplete="family-name"
                        appCapitaliseOnBlur
                        formControlName="lastName"
                        data-testid="waitlist-last-name"
                        [ngClass]="{
                            'is-invalid': form.get('lastName')?.invalid && form.get('lastName')?.touched
                        }"
                    />
                </div>
            </div>

            <input
                type="email"
                class="form-control"
                placeholder="Email Address"
                autocomplete="email"
                formControlName="emailAddress"
                data-testid="waitlist-email"
                [ngClass]="{
                    'is-invalid': form.get('emailAddress')?.invalid && form.get('emailAddress')?.touched
                }"
            />

            <div>
                <ngx-intl-tel-input
                    [cssClass]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched ? 'form-control is-invalid' : 'form-control'"
                    [preferredCountries]="[phoneNumberCountryCode]"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="phoneNumberCountryCode"
                    [separateDialCode]="false"
                    [maxLength]="15"
                    [numberFormat]="PhoneNumberFormat.International"
                    [phoneValidation]="true"
                    inputId="waitlistPhoneNumber"
                    name="waitlistPhone"
                    formControlName="phoneNumber"
                    data-testid="waitlist-phone-number"
                >
                </ngx-intl-tel-input>
                <div
                    *ngIf="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched"
                    class="invalid-feedback d-block"
                >
                    Please enter a valid phone number.
                </div>
            </div>

            <div
                *ngIf="waitlistError"
                class="alert alert-danger py-2 mb-0"
                data-testid="waitlist-error"
            >
                {{ waitlistError }}
            </div>

            <button
                class="btn btn-primary w-100 hstack justify-content-center gap-2"
                [disabled]="waitlistSubmitting"
                (click)="submitWaitlistEntry()"
                data-testid="waitlist-submit-button"
                type="button"
            >
                <span
                    *ngIf="waitlistSubmitting"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span>Join Waitlist</span>
            </button>
        </form>
    </ng-container>

    <ng-container *ngIf="waitlistSubmitted">
        <div
            class="text-center vstack gap-2 py-3"
            data-testid="waitlist-confirmation"
        >
            <div class="fs-2 text-success">✓</div>
            <div class="fw-semibold">You&apos;re on the waitlist.</div>
            <div class="text-body-secondary fw-normal">
                We&apos;ll email <strong>{{ form.get('emailAddress')?.value }}</strong> if a spot opens up.
            </div>
        </div>
    </ng-container>
</div>
